import React, { Fragment } from "react"
import { graphql, Link } from "gatsby"
import SEO from "../components/SEO"
import Header from "../components/header"
import Main from "../components/main"
import Footer from "../components/footer"
import Nav from "../components/nav"

function UpdatesPage(props) {
  const site = props.data.site.siteMetadata

  return (
    <Fragment>
      <SEO
        title={`Updates | ${site.title}`}
        description={site.description}
        url={site.url}
        imgUrl={`${site.url}/index_banner_02.png`}
      />
      <Nav />
      <Header siteTitle={site.title} />
      <Main>
        <h2>Recent Updates</h2>

        <p>If you experience any issues, have suggestions, or just want to let us know how much you enjoy this resource, don't hesitate to <a href="mailto:hello@inputsenpai.com">get in touch</a>!</p>

        <h3>February 8, 2020</h3>
        <p>I've updated the <Link to='/issai'>1歳 category</Link> books with all read-along YouTube video links that I could find.</p>

        <h3>January 18, 2020</h3>
        <p>Fixed a style issue with the percent bar on each age group card on the front page. Updated the colors on the age group to be more accessible. Also added the total number of books read to the front page progress bar. And! All the <Link to='/zerosai'>0歳 category</Link> YouTube read-along links have been added. Thanks and happy reading!</p>

        <h3>January 7, 2020</h3>
        <p>Happy new year! I hope your new year is starting off swimmingly. Just a quick update to say that I've added more read-along videos to the <Link to='/zerosai'>0歳 category</Link>. Due to changes in how YouTube handles content made for children, I won't be able to add them to playlists anymore. Anyway, let me know if you experience any issues! Happy reading!</p>

        <h3>December 28, 2019</h3>
        <p>Added the ability to <Link to='/import-export'>import and export your progress</Link> from your browser's database. This lets you transfer progress between browsers with ease! Please let us know if you run into any issues using this new feature.</p>

        <p>Also started adding read-along videos for the books as we find them. Click on the YouTube icon next to a book's title to see the read-along. Currently only one book has a linked read-along, but will add more as time goes on. We will also organize them into <a href="https://www.youtube.com/playlist?list=PLa2gq3wlv_qyLJxj9aYLElwGo-Jit0NmU" target="_blank" rel="noreferrer noopener">YouTube playlists</a>, if you want to go directly there.</p>

        <h3>December 15, 2019</h3>
        <p>Added info about where your progress is stored (in your browser). Also add ability to tweet your progress through the challenge.</p>

        <h3>December 3, 2019</h3>
        <p>Updated the user interface and the list of books.</p>
      </Main>
      <Footer />
    </Fragment>
  )
}

export const query = graphql`
  query UpdatesPageQuery {
    site {
      siteMetadata {
        title
        description
        url
      }
    }
  }
`

export default UpdatesPage
